<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Cards: {{ config?.name }}</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item">
            <a [routerLink]="['/organisations']">Organisations</a>
          </li>
          <li class="breadcrumb-item active">Cards</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<app-cards-form
  [organisationConfig]="config"
  (submitForm)="updateCards($event)"
  [loading]="loading"
  [errors]="errors"
></app-cards-form>
